export default __webpack_public_path__ + "static/media/murall-mobile.433c5073.svg";